:host {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  border: none;
  background: #ffffff;

  --aha-image-selector-item--width: 110px;
  --aha-image-selector-item--height: 98px;
  --aha-image-selector-item--selected-background: var(--theme-menu-active-background);
  --aha-image-selector-item--selected-color: var(--aha-gray-900);
}

#color-container {
  padding: var(--spacer-3) var(--spacer-4);
  background: var(--theme-tertiary-background);
}

:host([aria-current='true']) #color-container {
  background: var(--aha-image-selector-item--selected-background);
}

#image-container {
  display: flex;
  width: var(--aha-image-selector-item--width);
  height: var(--aha-image-selector-item--height);
  overflow: hidden;
  background: white;
  border-radius: var(--Common--border-radius);
  margin-bottom: var(--spacer-2);
}

#image-container img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  line-height: 0;
}

slot[name='label'] {
  color: var(--aha-gray-900);
  display: block;
  width: var(--aha-image-selector-item--width);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

:host([aria-current='true']) slot[name='label'] {
  color: var(--aha-image-selector-item--selected-color);
}
